import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useAuth } from '@/features/auth/hooks/useAuth';
import { PlanLandingResolver } from '@/features/auth/utils/PlanLandingResolver';

export const Route = createFileRoute('/_authenticated/')({
	component: AuthenticatedIndexRedirect,
});

function AuthenticatedIndexRedirect() {
	const { assistantEnabled, businessEnabled, isLoading } = useAuth();
	const navigate = useNavigate();

	useEffect(() => {
		if (isLoading) return;
		navigate({ to: PlanLandingResolver.resolve({ assistantEnabled, businessEnabled }), replace: true });
	}, [isLoading, assistantEnabled, businessEnabled, navigate]);

	return null;
}
